// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux'; // Import Provider
import { BrowserRouter } from 'react-router-dom';
import store from './redux/store'
import reportWebVitals from './reportWebVitals';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './assets/css/toastStyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/_Font.scss';
import Root from './Routes/Routes.dev';
import "./index.css"
import LayoutWrapper from './LayoutWrapper';
import './assets/fonts/embroidery/fonts.css';
import PasswordProtect from './PasswordProtect';
import KioskProvider from './KioskProvider';
// import ReactGA from "react-ga4";

// ReactGA.initialize("G-XXXXXXXXXX");
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}> {/* Wrap the app with Provider */}
    <BrowserRouter>
      <KioskProvider>
        <LayoutWrapper>
          {/* <PasswordProtect password="Embroidery@2025"> */}
            <Root />
          {/* </PasswordProtect> */}
        </LayoutWrapper>
      </KioskProvider>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        limit={1}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
reportWebVitals();

